import Footer from "~/components/common/Footer";
import PageContainer from "~/components/common/PageContainer";
import LandingHeader from "./header";
import GetApp from "~/components/common/GetApp";
import { useState } from "react";
import LandingCenter from "./center";
import LandingFeed from "./feed";

export default function Landing() {
  const [getAppOpen, setGetAppOpen] = useState(false);

  const onGetApp = () => {
    setGetAppOpen(true);
  };
  const onGoToShop = (tab?: string) => {
    if (tab && tab.length > 0) {
      window.open(`/shop?tab=${encodeURIComponent(tab)}`, "_blank");
    } else {
      window.open("/shop", "_blank");
    }
  };

  return (
    <PageContainer showHeader={false}>
      <div className="flex flex-col gap-[24px] bg-white">
        <LandingHeader onGetApp={onGetApp} onGoToShop={onGoToShop} />
        <LandingCenter onGetApp={onGetApp} onGoToShop={onGoToShop} />
        <LandingFeed onGoToShop={onGoToShop} />
        <Footer />
      </div>
      <GetApp open={getAppOpen} onOpenChange={setGetAppOpen} />
    </PageContainer>
  );
}
